query GetDripProgressions($editionId: ID!, $first: Int!, $after: String) {
    edition(id: $editionId) {
        id
        queuedDripProgressions(first: $first, after: $after) {
            totalCount
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    audienceMember {
                        id
                        audience {
                            id
                        }
                        entity {
                            id
                            name
                            avatarUrl
                            initials
                            htmlUrlPath
                            ... on Contact {
                                emailAddresses {
                                    primary {
                                        value {
                                            display
                                        }
                                    }
                                }
                                accounts {
                                    primary {
                                        id
                                        name
                                    }
                                }
                            }
                        }
                    }
                    nextEditionSendTime
                }
            }
        }
    }
}
